<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <img :src="item.headImg" alt="" />
          <a v-maidian="'link'+index" :href="item.linkId" class="line-btn"></a>
        </div>
      </div>
    </div>
    <!-- <img class="tip"
      src="https://s.qunarzz.com/srmweb/qunaradv/changma202203/29.png"
      alt=""
    /> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20230508-shijianchen-jump1.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 1000,
            tag: '服务贴心/早餐很赞',
            desc: '自由行 「MAZDA CX-50 行也同款线路」Club Med地中海俱乐部 丽江度假村1晚一价全含套餐（全天候一日三餐）',
            linkId:
              'https://qnel1.package.qunar.com/user/detail.jsp?abt=a&id=1171782885&',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20230508-shijianchen-jump2.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 403,
            desc: '小鹿辰客觅度设计美宿(亚龙湾博后村店)',
            tag: '环境舒适/客房干净',
            linkId:
              'https://qnel1.package.qunar.com/user/detail.jsp?abt=a&id=3087705468&',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20230508-shijianchen-jump3.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 872,
            desc: '杭州隐居江南·运河雅院',
            tag: '位置优越/风景优美',
            linkId:
              'https://qnel1.package.qunar.com/user/detail.jsp?abt=a&id=2214372125&',
            discountId: '1678403036',
          },
        ],
      ],
    };
  },
  methods: {
    jumpToSight(linkId) {
      location.href = linkId;
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  top: -36px;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  padding-top: 21px;
  &-box {
    margin-top: 99px;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 24px);
    box-sizing: border-box;
    border-radius: 3px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 100%;
    float: left;
    z-index: 2;
    margin-bottom: 14px;
    height: 145px;
    &-box {
      position: relative;
      margin-bottom: 7px;
      &:last-child {
        margin-bottom: 0;
      }
      // .bg-line {
      //     background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
      //         no-repeat;
      //     background-size: 100% auto;
      //     height: 20px;
      //     width: 100%;
      //     position: absolute;
      //     left: 0;
      //     bottom: 7px;
      // }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 7px;
    padding-top: 2px;
    padding-bottom: 0;
    box-sizing: border-box;
    float: left;
    width: calc(100% - 144px);
  }
  &-btm {
    padding: 7px;
    .price {
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        float: left;
        color: #ed4834;
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: '￥';
          font-size: 11px;
          position: relative;
        }
        &:after {
          content: '起';
          font-size: 11px;
          position: relative;
        }
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    float: left;
    width: 142px;
    height: 100%;
    img {
      display: block;
      height: 100%;
      width: 100%;
    }
  }
  .price {
    display: flex;
    align-items: center;
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background-color: #2c517f;
    border-radius: 6px;
    color: #fff;
    font-size: 11px;
    height: 24px;
    margin-left: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
.line-btn {
  position: absolute;
  width: 188px;
  height: 28px;
  right: 22px;
  bottom: 11px;
}
.line-cont-desc {
  font-size: 11px;
  color: #666;
  text-align: left;
  margin-top: 4px;
}
.v-line-desc {
  text-align: left;
  height: 40px;
  font-size: 15px;
}
.tip {
  width: 280px;
  display: block;
  margin: 0 auto;
}
</style>